import { GraphQLClient } from 'graphql-request'

const domain = process.env.NEXT_PUBLIC_SHOPIFY_DOMAIN
const token = process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_TOKEN

export default function useStorefront() {
	const endpoint = `https://${domain}/api/2024-01/graphql.json`
	const headers = {
		'X-Shopify-Storefront-Access-Token': token,
	}
	return new GraphQLClient( endpoint, { headers })
}
